// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2KZCV","consentsList":"PatientConsents_consentsList__1E6QH","consentsListEmpty":"PatientConsents_consentsListEmpty__CYJZ6"};